module.exports = __webpack_public_path__ + "img/flip.e82a551e.png";